function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import React, { createContext, useContext, useEffect, useReducer, useMemo } from "react";
import * as carouselActions from "./CarouselContextActions";
import { useColCount } from "../hooks/useColCount";
import reducer from "./CarouselContextReducer";
import { useUniquePrefix } from "../../../hooks/useUniquePrefix";
var CarouselContext = createContext({
    state: {
        nextSlidesCount: 0,
        previousSlidesCount: 0,
        slideIndex: 0,
        slideCount: 0,
        slideLabels: [],
        prefixId: ''
    },
    actions: {
        goNext: function() {},
        goPrevious: function() {},
        setSlideCount: function() {},
        setColCount: function() {},
        setSlideIndex: function() {},
        setSlideLabels: function() {}
    }
});
export var CarouselProvider = function(param) {
    var children = param.children, slideCount = param.slideCount, cols = param.cols, containerWidth = param.containerWidth, hideDots = param.hideDots, dotsMargin = param.dotsMargin, dotsSize = param.dotsSize, showOverhang = param.showOverhang, hideNumbers = param.hideNumbers, slideHeight = param.slideHeight, _scrollLock = param.scrollLock, scrollLock = _scrollLock === void 0 ? true : _scrollLock, isRtl = param.isRtl, testID = param.testID, insetControls = param.insetControls, controlsVerticalPosition = param.controlsVerticalPosition, announceNav = param.announceNav, dotsAriaLabel = param.dotsAriaLabel;
    var prefixId = useUniquePrefix('CarouselProvider');
    var ref = _slicedToArray(useReducer(reducer, {
        slideIndex: 0,
        slideCount: slideCount,
        nextSlidesCount: 0,
        previousSlidesCount: 0,
        cols: typeof cols === 'number' ? cols : undefined,
        slideLabels: Array(slideCount).fill(false),
        prefixId: prefixId
    }), 2), state = ref[0], dispatch = ref[1];
    var actions = useMemo(function() {
        return {
            goNext: carouselActions.goNext(dispatch),
            goPrevious: carouselActions.goPrevious(dispatch),
            setColCount: carouselActions.setColCount(dispatch),
            setSlideCount: carouselActions.setSlideCount(dispatch),
            setSlideIndex: carouselActions.setSlideIndex(dispatch),
            setSlideLabels: carouselActions.setSlideLabels(dispatch)
        };
    }, [
        dispatch
    ]);
    useColCount(cols, actions.setColCount, containerWidth);
    useEffect(function() {
        if (state.slideCount !== slideCount) {
            actions.setSlideCount(slideCount);
        }
    }, [
        slideCount,
        state.slideCount,
        actions
    ]);
    return _jsx(CarouselContext.Provider, {
        value: {
            state: _objectSpread({}, state, {
                hideDots: hideDots,
                dotsAriaLabel: dotsAriaLabel,
                dotsMargin: dotsMargin,
                dotsSize: dotsSize,
                showOverhang: showOverhang,
                hideNumbers: hideNumbers,
                slideHeight: slideHeight,
                scrollLock: scrollLock,
                isRtl: isRtl,
                testID: testID,
                insetControls: insetControls,
                containerWidth: containerWidth,
                controlsVerticalPosition: controlsVerticalPosition,
                announceNav: announceNav,
                prefixId: prefixId
            }),
            actions: actions
        },
        children: children
    });
};
export var useCarousel = function() {
    return useContext(CarouselContext);
};
